import { config } from 'CONFIG';

let year = new Date().getFullYear();

export default {

    lang: {

        mobile: {

            zh: '中文'

        },
        pc: {

            zh: '中文'

        }

    },

    common: {

        OK: 'OK',
        and: 'and'

    },

    nav: {
        homepage: '首页',
        dashboard: '控制面板',
        cloud: '视频库',
        play: '播放'
    },
    login: {
        dashboard: '控制面板',
        videoNav: '视频',
        accountSettings: '账户中心',
        profile: '我的',
        accountSecurity: '账户安全',
        logIn: '登录',
        signUp: '注册',
        logOut: '登出'
    },

    homepage: {
        btnSubmit: '提交',
        cloud_library: '云视频库',
        entryTitle: 'Reolink云服务',
        entrySubTitle: '云端存储，安全快捷',
        available_area: '假如Beta测试; 仅支持<span>美国。</span>',
        btnLogin: '登录',
        btnDredge: '注册',
        seePlan: '选择您需要的云服务套餐',
        for_other_area: '订阅最新云服务动态及信息。',
        videoRecordSubTtitle: '云视频存储',
        videoRecordTtitlePC: '保存一切发生过的事情，安全在云端',
        videoRecordTtitle: '保存一切发生过的事情，安全在云端',
        videoRecordDes: '开通云录像服务后，摄像机一旦检测到任何画面变化，将自动开始进行云录像，无需额外存储设备，再也不用担心因意外导致的本地录像丢失。您可在Reolink App或者Reolink云视频网站随时随地访问您的云录像。(注：仅支持移动侦测录像上传到云。）',
        plan_title: '选择云套餐',
        plan_title_m: '选择您需要的云服务套餐',
        money_back_1: '退款保证',
        money_back_2: 'SSL安全加密',
        money_back_3: '支持',
        securityBannerTitle: '支持Reolink产品',
        securityBannerDesLi11: '支持Reolink K1, K2, A1, A2。',
        securityBannerDesLi12: '无网无电源，云端存储移动侦测录像。',
        securityBannerDesLi13: '查看更多',
        securityBannerDesLi21: '同时支持',
        securityBannerDesLi3: `计划支持更多Reolink摄像机. <a class="text-link" target="_blank" href="${config.subscribeUrl}">订阅</a> 最新云服务动态。`,
        productSubscribeTitle: '您期望支持的摄像机:',
        successTips: '提交成功。',
        errTips: '不能为空。',
        faqsTitle: '常见问题',
        faqsQues: {
            account: {
                ques: '如何创建云服务账户？',
                des: [
                    '云服务账户与Reolink App账户为同一账户。如果您已经在Reolink App注册了账户，您可使用该账户登录并访问云服务网站。',
                    `如果您没有注册过Reolink App或云服务账户，您可在页面右上角进行注册或点击 <a target="_blank" href="${config.signipRedirect}">注册</a> 进行下一步操作。`
                ]
            },
            upload: {
                ques: '如何上传视频到云服务？',
                des: [
                    '如果您的账户已经订阅了Reolink云服务套餐，您绑定在该账户下的设备会自动将移动侦测录像上传到云端进行存储。存储在云服务的视频在套餐规定的时间内或者套餐到期后会自动删除，您也可手动删除云服务的视频。'
                ]
            },
            history: {
                ques: '如何查看云服务存储的历史视频？',
                des: [
                    '在Reolink App或云服务网页端登录云账户，即可查看云视频库中存储的历史视频。'
                ]
            }

        },
        basic_free_des: '免费套餐 - 无需押金',
        basic_des: '不错过任何一个重要的画面',
        get_start_now: '订阅免费套餐',
        choose_product: '选择使用的摄像机',
        cloud_support: '更多云服务相关问题',
        plan_discount: '{discount}% 折扣',
        subscribe_plan_button: '订阅云服务',
        introducing_title: '金融级加密',
        introducing_Subtitle: '安全实打实储',
        introducing_des: '依托阿里云为技术支持，采取金融级别的防御措施，动态加密传输数据。一个账号、一台或多台设备，对应一个独立云空间;不担心数据丢失或隐私泄露，规避设备被盗关键证据丢失的风险。从头至尾，一丝不苟，全程加密。',
        limitNote: 'Reolink云服务暂时仅支持以下摄像机 {device} 及在 {country} 开放。',
        compatibility: {
            title: '查看云服务支持范围',
            countryTitle: '支持的国家与地区',
            deviceTitle: '支持的摄像机',
            notice: '计划支持更多Reolink摄像机，订阅我们以获得最新动态。',
            notify: '订阅最新消息'
        }
    },

    dashboard: {
        name: '控制面板',
        videoNav: '云视频库',
        myVideo: '我的视频',
        video: '视频',
        plan: '我的套餐',
        noplan: '0 套餐',
        cloudSpace: '我的空间',
        moreSpace: '购买更多空间',
        device: '我的设备',
        moreCamers: '购买更多摄像机',
        help: '需要帮助？',
        cantact: '联系客服',
        ask: '求助论坛',
        facebook: 'Facebook',
        twitter: 'Twitter',
        accountSettings: '账户设置',
        no_video: '0 视频',
        no_device: '0 摄像机',
        current_plan: '当前套餐:',
        vaild_time: '有效期截止时间:',
        cameras_assigned: '绑定摄像机:',
        space: '存储空间:',
        cancel: '我想取消',
        server_plan: '订阅云服务套餐',
        payment_history: '我的云服务历史付费账单',
        unassign: '解除绑定',
        how_to_bind: '如何绑定摄像机到云服务账户',
        bind_url: 'https://reolink.com.cn/bind-camera-to-reolink-cloud-plan/',
        what_is_plan: 'https://reolink.com.cn/bind-camera-to-reolink-cloud-plan/',
        status: {

            processing: '支付完成',
            inactive: '未激活',
            expired: '已过期'

        },
        renew: '续费',
        items: {

            switch: '切换',
            switch_note: '(一周仅能操作一次)',
            cancel: '取消',
            cancel_note: '(取消后，不可再订阅本套餐。)'

        }
    },

    bindCamera: {
        uid: 'UID',
        name: '摄像机名',
        model: '型号',
        apply: '应用',
        cancel: '取消',
        status: '状态',
        no_camrea: '未绑定摄像机',
        how_to_bind: '如何绑定摄像机到云服务账户',
        shop_camera: '商城',
        unassigned: '未关联套餐',
        unbound: '未绑定。在Reolink App内绑定设备。',
        assigned: '已关联套餐',
        change_status: '切换摄像机状态',
        unassign_point: '云服务存储的视频一旦被删除，永不可恢复。如果您取消了摄像机关联的套餐，如果您未再次订阅新套餐，<strong> 视频会在 {leftTime} 天内被系统自动删除</strong>。',
        unassign_button: '未关联套餐',
        lab_link_hover: '开启云服务大码流服务',
        lab_link: '您的 #Reolink实验室',
        unlock_lab_btn: '关闭 #Reolink实验室 功能'
    },

    reolinkLab: {
        subTitle: '#Reolink实验室',
        title: '大码流实验项目',
        definition_title: '#Reolink实验室 是什么',
        definition_content: '#Reolink实验室 是邀请用户参与测试体验Reolink实验性质的新功能的项目。项目用户在体验中需反馈碰到的问题或建议，帮助提升/打造更优秀的Reolink摄像机。这些实验项目涉及的功能最后不保证一定会开放并应用到Reolink摄像机上。想要体验的用户需要主动申请开启体验才会加入到相关的实验项目中。',
        recording_title: '什么是大码流实验项目',
        recording_content: '针对有线摄像机，用户可以选择上传高清视频到云端（默认视频为标清分辨率。注：仅支持移动侦测录像上传到云。）',
        recording_feature_title: '提前告知',
        recording_point1_title: '#1. 摄像机网络带宽要求至少有10 Mbps。',
        recording_point1_detail: '带宽不足容易导致上传不成功，或上传速度慢从而导致后续的视频未录制到等问题。如果网络环境不足以支持高清视频的上传（如带宽不够，网络不稳定等），摄像机将自动降低码流上传标清视频。',
        recording_point2_title: '#2. 高清视频上传后保存的时长可能会缩短。',
        recording_point2_detail: '高清视频占据的空间极大，云存储空间非常容易被占满，一旦占满，会自动覆盖旧的视频（即，如果您是30天的套餐，如果您开启了优先上传高清视频，那么您的云空间的视频极有可能没有30天前的视频，具体能看到多少天以内的视频以您的套餐内的空间，您的设备上传的视频量为准。注：仅支持移动侦测录像上传到云。）',
        recording_device_title: '项目支持的摄像机',
        recording_device_detail: '这是个处于孵化器中的功能，目前仅E1的部分用户能看到这个功能的。',
        btn_no_interested: '不感兴趣',
        btn_try_to: '我想体验',
        apply_steps_one_title: '申请',
        device_title: '您的摄像机:',
        project_title: '体验项目:',
        project_content: '大码流实验项目',
        btn_apply: '开启实验',
        btn_refuse: '不，我再想想',
        apply_steps_two_title: '申请状态',
        success_apply: '您已成功<span>开启</span>大码流实验项目。',
        btn_cancel_apply: '关闭实验',
        btn_back_dashboard: '回到控制面板',
        success_cancel: '您已成功<span>关闭</span>大码流实验项目。',
        intro_title: '下一步：在Reolink App设置。',
        intro_detail1: '请确保您的App和摄像机固件已经是最新的版本。 ',
        intro_detail2: '打开云服务 {arrow} , 然后点击右上角的 {btnImg} 按钮。 选择摄像机，在视频分辨率处选择高清。 '
    },

    datepicker: {
        header: {
            year: '年',
            month: '月',
            day: '日'
        },
        confirm: 'OK',
        allTime: '所有时间',
        duration: '时间段'
    },
    cloud: {
        noVideo: '暂无视频。',
        toBeUpdated: '待更新··· ···',
        shopButton: '商城',
        reolinkCloudLink: '如何上传视频到云视频库',
        select: '选择下载或删除视频文件',
        selectedLabel: '切换去播放视频',
        showExpired: '仅显示3天内即将被删除的视频',
        renewal: '续费',
        noVerify: {
            title: 'Reolink云服务',
            subTitle: '云端存储，安全快捷',
            desc: [
                {
                    title: '免费。',
                    desc: 'Beta免费套餐。登录或注册账户开启摄像机视频云存储服务。'
                },
                {
                    title: '安全。',
                    desc: '使用HTTPS加密技术，存储传输一路安全可靠，无需担心信息泄露。'
                },
                {
                    title: '有效。',
                    desc: '自动上传移动侦测视频到云端。'
                }
            ],
            workWith: 'Reolink云服务暂时仅支持以下摄像机 {device} 及在 {country} 开放',
            subscriptionTitle: '订阅云服务套餐',
            subscriptionSubTitle: '您的云服务套餐账户关联手机号:',
            emailTip: `这是您的账户登录邮箱. 您可 <a class="theme-color" href="${config.accountCenterProfileUrl}" target="_blank">更改登录邮箱</a>。`,
            verified: '已验证',
            unVerified: '未验证',
            verifyButton: '验证邮箱',
            verifyButtonEnd: ' 为保证您的账户的安全性。',
            verifySuc: '验证邮件已被发送至该邮箱，请查收您的收件箱并按邮件内容继续下一步。',
            choosePlan: '选择套餐:',
            statement: `* 我已阅读并同意Reolink <a href="{conditions}" target="_blank">服务条款</a>, 及 <a href="{privacy}" target="_blank">隐私政策</a>。`,
            subscribe: '订阅',
            notice_verify_email: '请验证您的邮箱',
            notice_agree: `请确认您已阅读并同意Reolink的隐私条款及服务条款。`,
            notice_plan: '请选择一个套餐。',
            result_suc: '订阅成功。',
            result_failed: '订阅失败。',
            back_to_homepage: ' {0} 秒后页面跳转回我的云视频库...'
        },
        error: {
            title: '网络错误',
            des: '无法获得视频信息，请刷新本页面重试一遍。',
            refresh: '刷新',
            cancel: '取消'
        }
    },
    download: '下载',
    delete: '删除',
    selectAll: '全选',
    select: '选择',
    all: '所有',
    all_my_device: '所有我的设备',
    cancel: '取消',
    unbound: '未绑定',
    current_plan: '当前套餐',
    current_plan_abbr: '当前',
    comma: ',',

    footer: {
        logo: '时刻都在现场',
        cloud: '云服务',
        app_store: 'APP Store',
        google_pay: 'Google Play',
        aboutUs: '关于我们',
        term: '服务条款',
        policy: '隐私条款',
        reolinkStore: 'Reolink商城',
        copyright: `Copyright ${year} © Reolink 版权所有`,
        link_cloud: '云服务网页端',
        support: '帮助中心'
    },

    video: {

        download: '下载',
        del: '删除',
        share: '分享给朋友',
        otherVideos: '其他视频:',
        more: '更多',
        goBack: '返回'

    },

    dialog: {

        del: '您确定要删除这些视频吗?',
        updateTitle: '视频标题不能多于127个字符。',
        yes: '是',
        no: '否',
        save: '保存',
        cancel: '取消',
        ok: '确定'

    },

    errors: {

        err_1: '此项为必填。',
        err_update_title: '视频标题修改失败。',
        err_del_video: '视频删除失败。',
        delete_video: '视频删除失败。',
        verify_email: '邮箱验证失败。',
        verify_email_detected: '验证次数太多，请稍后再重试。 ',
        login_expired: '您的登录信息过期，请重新登录。',
        logout_forced: '信息已过期，请刷新页面重试',
        download_video: '下载失败。',
        assign_success: '关联成功。',
        assign_fail: '关联失败。',
        unassign_success: '解除关联成功。',
        unassign_fail: '解除关联失败。',
        operation_suc: '操作成功。',
        invalid_email: '请输入有效邮箱地址。',
        server_error: '服务器错误。',
        duplicate_submission: '重复提交，该邮箱已存在。',
        frequent_submission: '提交失败，请重试。',
        video_no_found: '抱歉，该视频不存在。',
        error_unknow: '未知错误，请重试。',
        no_plan_to_switch: '尚无订阅套餐。请确保您已登录正确的Reolink账户。',
        frequent_switching: '无法切换，请一周后重试。',
        no_plan_selected: '请选择套餐。',
        frequent_confirm_payment: '您的支付已完成，可返回控制面板获得套餐最新状态。',
        checkbox_required: '标*内容为必填。',
        field_required: '标*内容为必填。',
        sub_processing: '处理中··· ···请稍后重试。',
        plan_not_available: '抱歉，该套餐暂时不可用。',
        can_not_renew: '当前基础套餐暂时不可续费。',
        plan_not_exist: '抱歉，该套餐暂时不可用。',
        can_not_switch: '无法切换。 (该套餐一周仅能切换一次。)',
        cannot_update_refund: '您有待退款项，暂时无法提交另一个退款申请。',
        plan_renew_only: '无法订阅或切换该套餐。该套餐仅可续费。',
        payer_account_required: '请填写PayPal账户。'
    },

    suc: {

        delete_video: '视频删除成功。',
        verify_email: '邮箱验证成功。'

    },

    comfirm: {

        delete_video: '确定要删除该视频文件？',
        password_changed: '您的密码已更新，请重新登录。'

    },

    pagination: {

        prev: '前一页',
        next: '后一页',
        jump: '前去页面',
        page: ''

    },

    meta: {

        homepage: 'Reolink云服务：视频云存储，安全便捷',
        dashboard: '我的云服务 - Reolink',
        library: '我的云视频库 - Reolink',
        play: '播放云视频 - Reolink',
        cart: '我的云服务 - Reolink',
        '404': '404 - Reolink',
        subscribePlan: '订阅云套餐 - Reolink',
        cloudPlanPaymentHistory: '云历史支付账单 - Reolink',
        updatePlan: '更新云套餐 - Reolink',
        invoice: '账单凭证 - Reolink',
        cancelPlan: '取消云套餐 - Reolink',
        cancelPlanComplete: '取消云套餐 - Reolink',
        paymentCallback: '处理中 - Reolink Cloud',
        orderComplete: '更新云套餐 - Reolink',
        switchSuccess: '更新云套餐 - Reolink'

    },

    cancelSubscription: {

        title: '取消订阅云套餐',
        subTitle: '确定要取消订阅云套餐 {planName}? 一旦取消，您将不再享有以下服务:',
        des: '取消套餐后，如果不在7天内订阅新套餐，您的云视频将会被系统自动删除（不可恢复。）请在被删除前下载保存。(注：云存储服务仅支持移动侦测录像。）',
        label: '好的，我知道了。 *',
        support: `我们真心希望您能获得美好的云服务体验，如需帮助，欢迎随时联系我们 <a href="mailto:${config.support_email}" target="_blank">${config.support_email}</a>，我们将竭诚为您服务。`,
        keep: '不，保留订阅当前套餐',
        cancel: '是的，取消订阅当前套餐'
    },

    plan: {

        history: `<span>%{history}-天</span> 云视频存储记录`,
        camera: `支持<span>1</span> 摄像机 | <span>{count}</span> 摄像机`,
        storage: `<span>%{storage}GB</span> 云视频空间`,
        maxHistory: `长达 <span>%{history}-天</span> 云视频存储记录`,
        maxCamera: `最多支持 <span>1</span> 摄像机 | 最多支持 <span>{count}</span> 摄像机`,
        maxStorage: `最大支持 <span>%{storage}GB</span> 云视频空间`,
        limited_day: '有效期截止时间 {monthAbbr}. {dateOfMonthOrder} {year} (PST)',
        free: '免费',
        dot: ',',
        only_for_us: '当前仅支持美国',
        subscribe: '订阅',
        beta_notice: '2019开放',
        stock: '剩余{count} 席位 |剩余 {count} 席位 |剩余 {count} 席位',
        discount: '{discount}% 折扣'

    },

    maxDeviceQuantity: '最多支持 1 摄像机 | 最多支持 {count} 摄像机',

    cycle: {

        day: '天 | {count}-天',
        week: '周 | {count}-周',
        month: '月 | {count}-月',
        year: '年 | {count}-年'

    },

    cycle_short: {

        day: '天 | {count}-天',
        week: '周 | {count}-周',
        month: '月 | {count}-月',
        year: '年 | {count}-年'

    },

    cycle_unit: {

        day: '天 | {count}-天',
        week: '周 | {count}-周',
        month: '月 | {count}-月',
        year: '年 | {count}-年'

    },

    cycle_count: {

        day: '{count} 天 | {count} 天',
        week: '{count} 周 | {count} 周',
        month: '{count} 月 | {count} 月',
        year: '{count} 年 | {count} 年'

    },

    day: '天',
    week: '周',
    month: '月',
    year: '年',
    subscription: '订阅',
    plan_item_subscription: '订阅',

    login_error: {

        refresh: '刷新',
        login: '重新登录',
        title: '网络错误',
        des: '获取账户信息失败，请刷新页面重试一遍。'

    },

    cancel_plan: {

        title: '取消 {planname}',
        plan_details: '当前套餐信息：',
        account: '账户',
        current_plan: '当前套餐',
        vaild_time: '有效截止时间',
        refund: '剩余金额',
        before_cancel: '一旦取消订阅套餐，您 <span class="red">不再</span> 享有以下服务:',
        are_you_sure: '确定要取消订阅当前套餐吗? ',
        take_effect: '取消操作将 <span class="red">立即生效</span>.',
        two_week_clean: '所有账户中的云视频将在 <span class="red"> 7 天内删除，无法恢复</span>. 请确保删除前已下载和保存好需要的视频。(注：云存储服务仅支持移动侦测录像。）',
        cancel_reason: '套餐哪里不合适吗? 请告诉我们，我们马上可以变得更好用！',
        switch_plan: '切换套餐',
        reason_first: '我想切换套餐。',
        reason_second: '我更喜欢存储在本地。',
        reason_third: '现有的套餐太贵啦。',
        reason_forth: '其他理由',
        notice: `我们真心希望您能获得美好的云服务体验，如需帮助，欢迎随时发送邮件到 <a class="text-link" href="mailto:${config.support_email}">${config.support_email}</a>，我们将竭诚为您服务。`,
        got_it: '好的，我知道了',
        no_keep: '不，我要保留现有套餐',
        yes_cancel: '是，我要取消现有套餐'
    },

    cancel_complete: {

        title: '取消 {planname}',
        plan_status: '已成功取消。',
        plan_decf: '如原套餐尚有余额，将按照原路径返回',
        plan_decs: '在7个工作日内',
        plan_dect: '.',
        notice: `如需帮助，欢迎联系 <a class="text-link" href="${config.support_team}" target="_blank">客服</a>.`,
        sure_ok: '好的',
        beta_note: `很遗憾您选择离开，感激您曾选择了我们，希望稍后能再次同行。`
    },

    order_complete: {

        order_status_success: '您的账单详情如下。',
        contact_us_success: `感谢您的购买。如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>。(注：云存储服务仅支持移动侦测录像。）`,
        contact_us_pending: `如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。(注：云存储服务仅支持移动侦测录像。）`,
        contact_us_processing: `如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。(注：云存储服务仅支持移动侦测录像。）`,
        order_status_fail: '支付失败。',
        contact_us_fail: `支付失败。如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。(注：云存储服务仅支持移动侦测录像。）`,
        fail_reason1: '失败: 服务器错误。',
        fail_reason2: '已过期: 支付请求已过期。',
        order_status_cancel: '账单取消。',
        contact_us_cancel: `如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。`,
        payment_id: '账单ID: ',
        payment_date: '账单日期： ',
        payment_status: '账单状态: ',
        cloud_plan: '云套餐',
        plan_cycle: '支付周期',
        total: '总计',
        currency: 'RMB',
        my_library: '我的云视频库',
        upload_video: '如何上传视频到云视频库',
        tryAgain: '重试',
        titlePending: '待支付... ...',
        titleProcessing: '支付处理中... ...',
        titleComplete: '支付成功。',
        somethingWrong: '未知错误，页面返回失败。',
        refresh: '刷新页面重试',
        toMyPlan: '返回套餐页面'

    },

    switch_plan: {

        switch_free_title: '切换成功',
        switch_free_detail: '新套餐信息如下:',
        plan_name: '新套餐',
        vaild_time: '有效期截止时间',
        free_tip: '(需人工续费。)',
        refund_info: '如原套餐尚有余额，将按照原路径返回。',
        contact_us_switch: `如需帮助，欢迎随时联系我们<a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。(注：云存储服务仅支持移动侦测录像。）`,
        sure_ok: '好的',
        renewal_free: '续费成功。',
        open_free: '订阅成功。',
        contact_us_renew: `如需帮助，欢迎随时联系我们 <a class="text-link" href="${config.support_team}" target="_blank">客服</a>，我们将竭诚为您服务。(注：云存储服务仅支持移动侦测录像。）`,
        my_library: '我的云视频库',
        upload_video: '如何上传视频到云视频库'

    },

    cart_nav: {

        choose_plan: '选择套餐',
        confirm_details: '确认信息',
        complete: '完成',
        switch_plan: '切换套餐'

    },

    cart: {

        title: {

            subscribe: '订阅{plan}',
            switch: '切换 {plan}',
            renew: '续费 {plan}'

        },
        appTitle: {

            subscribe: '购买套餐',
            switch: '切换套餐',
            renew: '续费套餐'

        },
        plan_details_title: {

            subscribe: '订阅套餐详情:',
            switch: '新套餐详情:',
            renew: '套餐续费详情:'

        },
        plan: {

            title: '云套餐',
            price: '价格',
            valid: '有效期截止时间',
            cycle: '付费周期'

        },
        credict_cart: {

            visa: 'Visa',
            discover: 'Discover',
            mastercard: 'Mastercard',
            amex: 'American Express',
            paypal: 'PayPal'

        },
        cycle_title: '如果您选择月套餐，一个付费周期为一个月。如果您选择年套餐，一个付费周期为一年。',
        total: 'Total',
        switch: {

            title: '重要提示',
            sub_title: '在您切换前，您须知：',
            list: [

                '一旦切换成功，新套餐将<span class="red">立即生效</span> 。(注：云存储服务仅支持移动侦测录像。）',
                '您的订阅将按实际使用情况计算，如原套餐尚有余额，将自动按照新套餐费用换算给新套餐使用。',
                `一旦 <span class="red">降级套餐到低版本</span>, 大于新套餐允许绑定数量限制的摄像机将被 <span class="red">自动解绑</span>. 多于新套餐限定范围的视频将被<span class="red">立即删除</span> ，无法撤回，不可恢复。 如需要保存，请注意提前下载并保存。   <a target="_blank" href="https://support.reolink.com/hc/en-us/articles/360008380934" class="ui-link more-details"><span class="text">查看更多详情</span><i class="ui-icon icon-icon_arrow-right"></i></a>`

            ],
            help: `如需帮助，请随时联系我们<a class="text-link" href="mailto:${config.support_email}">${config.support_email}</a>， 我们将竭诚为您服务。`,
            ok: '<span class="red">*</span> 好的，我知道了。'

        },
        payment: {

            title: '支付方式',
            pay_via: '选择'

        },
        agreement: `<span class="red">*</span> 我已仔细阅读并同意Reolink <a class="text-link" href="{privacy}" target="_blank">隐私条款</a> 和 <a href="{conditions}" target="_blank" class="text-link">服务条款</a>`,
        switch_note_1: `<span class="red">*</span> 您的订阅将按实际使用情况计算，如原套餐尚有余额，将自动按照新套餐费用换算给新套餐使用。新套餐付费周期将从上一个套餐余额使用完毕后开始计算。`,
        switch_note_2: `一旦降级套餐到低版本， 多于新套餐限定范围的视频将被立即删除 ，无法撤回，不可恢复。 如需要保存，请注意提前下载并保存。(注：云存储服务仅支持移动侦测录像。） `,
        bottom: {

            accept: '支持',
            ssl: '支付已加密',
            security: '使用SSL加密技术保证付款安全。',
            privacy: '您输入的个人信息仅作为订单使用，我们不会将任何个人信息出售给第三方。 更多详见 <a class="text-link" href="{privacy}" target="_blank">隐私政策</a>。'

        },
        checkout: {

            subscribe: {
                pay: '下一步',
                free: '下一步'
            },
            switch: {

                pay: '是, 切换并支付新套餐',
                free: '是, 切换到新套餐'

            },
            renew: {

                pay: '下一步',
                free: '确认续费'

            }

        },
        cancel: {

            subscribe: '取消',
            switch: '否, 保留当前套餐',
            renew: '取消'

        },
        cycle_tip: '如果您选择月套餐，一个付费周期为一个月。如果您选择年套餐，一个付费周期为一年。',
        payment_tip: `行业最大的在线支付方式。安全，快捷，无附加费用。`,
        payment_tip_link: '了解PayPal更多内容',
        empty: {

            title: '这里现在空空如也。',
            button: '返回首页'

        },
        money_back: '退款保证',
        countryLimitTitle: '注意事项',
        countryLimitDes: 'Reolink云服务现仅在 {country} 开放。',
        countryLimitConfirm: '明白，继续下一步',
        limitTitle: '重要提示',
        supportTip: 'Reolink云服务仅支持以下摄像机。',
        limitCountries: '开放国家',
        limitProducts: '支持摄像机'

    },

    payment_history: {

        title: '云账单付费历史记录',
        id_label: '账单ID',
        date_label: '账单日期',
        total_label: '总计',
        plan_label: '套餐',
        status_label: '状态',
        pay_now: '立马支付',
        invoice: '账单凭据',
        load_more: '加载更多',
        show_less: '收缩内容',
        refunding: '退款中'

    },

    payment_status: {

        refunding: '退款中',
        manual_refunding: '退款中',
        refunded: '已退款',
        expired: '已过期',
        cancelled: '已取消',
        completed: '已完成',
        processing: '处理中',
        pending: '待支付',
        failed: '失败'

    },

    update_plan: {

        title: '切换 {plan}',
        sub_title: '当前套餐详情:',
        switch_title: '我想切换至: <span class="red">(一周仅能切换一次)</span>',
        account_label: '账户',
        plan_label: '当前套餐',
        valid_label: '有效期截止时间',
        refund_label: '套餐余额',
        confirm_button: '下一步',
        cancel_button: '我再想想'

    },

    payment_processing: {

        title: '支付处理中... ...',
        des: '请稍后。',
        back_to_app: '返回Reolink',
        app_note: '注: 如果您使用除Chrome, Safari以外的浏览器，该按钮有可能点击没反应。您可直接返回Reolink云服务网页端或Reolink App刷新支付结果。'

    },

    date_resolve: {

        date_res: '{en_date}'

    },

    date_format: {

        default: '{month}/{day}/{year}'

    },

    videoQuantityConfirm: {
        currentQuantity: '您已绑定摄像机数量: <span class="strong red">{quantity}</span>.',
        subTitle: '然而您目前选择',
        planQuantity: '{plan} 仅支持绑定 <span class="strong"><span class="red">{quantity}</span> 摄像机</span>.',
        title: '您确定要切换吗？',
        confirm: '确定',
        cancel: '选择其他套餐'
    },

    emailSubscription: {
        title: '订阅云服务的动态及折扣消息.',
        placeHolder: '邮箱地址',
        button: '提交',
        note: '* 一旦云服务有新动态，我们会第一时间通知您。',
        successText: '您已成功订阅！'
    },

    countrySelectSpinner: {
        placeholder: '国家/地区',
        chooseClue: '选择您所在的国家/地区',
        notAvailable1: '暂不支持该国家/地区。',
        getNotified: '通知我',
        notAvailable2: ' 该区域开放时',
        differentClue: '您选择的国家/地区与您主页中的信息不一致，请确认您已选择正确。'
    },
    productSelectSpinner: {
        placeholder: '支持摄像机',
        chooseClue: '请选择您能使用云服务的摄像机',
        notAvailable: '未匹配到结果'
    },

    itemList: {
        noMatch: '抱歉，Reolink云服务暂不可用。'
    },

    share: {
        list: {
            title: '分享摄像机给其他⼈使⽤',
            addBtn: '新增分享',
            management: '分享管理'
        },
        delete: {
            user: '使用人',
            authority: '分享权限',
            deleteBtn: '删除分享'
        },
        authority: {
            title: '选择分享权限',
            shareBtn: '分享',
            maxShare: '此功能最多分享给 {maxShare} ⼈使⽤'
        },
        code: {
            title: '邀请好友扫描下⽅⼆维码，分享该摄像机。',
            expired: '二维码有效期为 {expired} 分钟',
            maxNum: '，最多⽀持 {maxNum} ⼈分享使⽤'
        },
        installGuide: {
            title: 'Reolink智能摄像机分享',
            des: '简单两步即可观看监控视频',
            stepOne: {
                stepNum: '第一步',
                stepDes: '点击下⽅安装按钮下载安装Reolink APP，如果已安装请直接查看下⼀步。',
                button: '免费安装Reolink APP'
            },
            stepTwo: {
                stepNum: '第二步',
                stepDes: '打开Reolink APP，点击⾸⻚右上角的“添加”按钮，扫描分享的⼆维码，添加设备。'
            }
        },

        popUp: {
            confirm: '确认',
            cancel: '取消',
            codeExpired: '添加失败，⼆维码已过期。',
            failed: '添加失败',
            failedReason: '二维码已失效，可联系分享者重新进行分享。',
            delete: '删除',
            deleteTip: '删除分享',
            deleteShare: '删除分享后，分享⽤户将⽆法继续使⽤该摄像机，是否确认删除分享？',
            deleteShareFail: '删除失败，请稍后再试',
            shareTip: '分享提示',
            shareFail: '分享失败，请稍后再试',
            add: '添加'
        },

        addSharedDevice: {
            sharedBy: '该摄像机是来⾃{user}⽤户的分享，你可操控摄像机权限包括： '
        },

        pageTitle: {
            addSharedDevice: '添加设备',
            share: '分享',
            createShared: '新增分享'
        }
    }

};



// WEBPACK FOOTER //
// ./src/lang/oem/reolink-cn/zh.js